<template>
  <div class="categories-action">
    <div class="pinned-services">
      <Service
        v-for="service in pinnedServices"
        :key="service.id"
        :service="service"
        :checked-services="checkedServices"
        @update="handleUpdateChecked" />
    </div>
    <Category
      v-for="category in options"
      :key="category.id"
      :checked-services="checkedServices"
      :category="category"
      @update="handleUpdateChecked" />
    <ButtonAction
      v-if="options.length"
      class="mt-3"
      :data="{ label: data.label }"
      :is-disabled="isValidationDisabled"
      :is-large="isLarge"
      @validate="validate" />
  </div>
</template>

<script>
import ButtonAction from "@/components/chatbot/Bubbles/actions/ButtonAction"
import Category from "@/components/chatbot/Bubbles/actions/category/Category.vue"
import Service from "@/components/chatbot/Bubbles/actions/category/Service.vue"

export default {
  name: "CategoriesCheckboxesAction",
  components: {
    ButtonAction,
    Category,
    Service
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkedServices: [],
      openedGroup: null
    }
  },
  computed: {
    pinnedServices() {
      let pinnedServices = []

      this.options.forEach(category => {
        category.services.map(service => {
          if (service.pinned && !pinnedServices.some(s => s.id == service.id)) {
            pinnedServices.push(service)
          }
        })
      })

      return pinnedServices
    },
    isValidationDisabled() {
      if (!this.options.length) {
        return true
      }

      if (!this.checkedServices.length) {
        return true
      }

      return false
    }
  },
  created() {
    this.options = JSON.parse(JSON.stringify(this.data.options))
  },
  methods: {
    validate() {
      this.$emit("validate", this.checkedServices)
    },
    handleUpdateChecked(service) {
      let currentService = this.checkedServices.find(checkedService => checkedService.value === service.value)

      if (currentService && !service.action) {
        this.checkedServices.splice(this.checkedServices.indexOf(currentService), 1)
        return
      }

      if (currentService) {
        currentService.action = service.action
        return
      }

      this.checkedServices.push(service)
    }
  }
}
</script>

<style lang="scss">
.categories-action {
  .el-checkbox {
    .el-checkbox__label {
      font-size: 14px;
      white-space: normal;
      padding-left: 0;
    }

    .el-checkbox__input {
      display: none;
    }
  }

  .el-checkbox.is-bordered + .el-checkbox.is-bordered {
    margin-left: 0;
  }
}
</style>

<style lang="scss" scoped>
.categories-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  flex-shrink: 0;
  gap: 30px;

  .pinned-services {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px 0;
    border-bottom: 1px solid color(gray05);
    border-top: 1px solid color(gray05);
  }
}
</style>
